import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from 'react-intl';
// import { FormattedMessage } from "react-intl";
import { Link, Route } from "react-router-dom";
import ClickOutside from "../components/ClickOutside";

const ImgToolTip = ({tooltiptext, id, img}) => (
  <OverlayTrigger
    placement="right"
    overlay={
      <Tooltip id={id}>
        <FormattedMessage id={tooltiptext} />
      </Tooltip>
    }
  >
    <img src={`/icons/${img}`} alt={tooltiptext} />
  </OverlayTrigger>
)

const Sidebar = ({ locale, setLocale }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [selected, setSelected] = React.useState('events');

  return (
    <Route
      render={({ location, history }) => (
        <ClickOutside
          onClickOutside={() => {
            setExpanded(false);
            document.body.classList.remove("side-expanded");
          }}
        >
          <SideNav
            className="custom-sidenav"
            expanded={expanded}
            onToggle={(expanded) => {
              setExpanded(expanded);
              if (expanded) {
                document.body.classList.add("side-expanded");
              } else {
                document.body.classList.remove("side-expanded");
              }
            }}
            onSelect={(selected) => {
              setSelected(selected);
              if (selected === "events") {
                if (location.pathname !== "/") {
                  history.push("/");
                }
                return;
              }
              const to = "/" + selected;
              if (location.pathname !== to) {
                history.push(to);
              }
            }}
          >
            <SideNav.Toggle
              className="toggle-elm"
              style={{ display: "flex", alignSelf: "flex-end" }}
            />
            <SideNav.Nav selected={selected } className="side-nav-nav" defaultSelected="events">
              <Link className="logo" to="/">
                <img
                  className="logo-icon"
                  src="/images/logo-icon.png"
                  alt="Icon"
                />
                <img className="logo-text" src="/images/logo.png" alt="Logo" />
              </Link>
              <NavItem eventKey="events">
                <NavIcon>
                  <ImgToolTip tooltiptext="tooltip.event" id="tooltip-event" img="s-1.png" />
                </NavIcon>
                <NavText><FormattedMessage id="nav.events" /></NavText>
              </NavItem>
              <NavItem eventKey="rooms">
                <NavIcon>
                  <ImgToolTip tooltiptext="tooltip.room" id="tooltip-room" img="s-2.png" />
                </NavIcon>
                <NavText><FormattedMessage id="nav.rooms" /></NavText>
              </NavItem>
              <NavItem eventKey="speakers">
                <NavIcon>
                  <ImgToolTip tooltiptext="tooltip.speakers" id="tooltip-speakers" img="s-3.png" />
                </NavIcon>
                <NavText><FormattedMessage id="nav.speakers" /></NavText>
              </NavItem>
              <NavItem eventKey="plusoptions">
                <NavIcon>
                  <img src="/icons/s-4.png" alt="options icon" />
                </NavIcon>
                <NavText><FormattedMessage id="nav.options" /></NavText>
                <NavItem eventKey="themes">
                  <NavText><FormattedMessage id="nav.themes" /></NavText>
                </NavItem>
                <NavItem eventKey="types">
                  <NavText><FormattedMessage id="nav.types" /></NavText>
                </NavItem>
                <NavItem eventKey="associations">
                  <NavText><FormattedMessage id="nav.associations" /></NavText>
                </NavItem>
                <NavItem eventKey="sessions">
                  <NavText><FormattedMessage id="tab.schedule-sessions" /></NavText>
                </NavItem>
              </NavItem>
              <NavItem eventKey="contact">
                <NavIcon>
                  <ImgToolTip tooltiptext="tooltip.contact" id="tooltip-contact" img="s-5.png" />
                </NavIcon>
                <NavText><FormattedMessage id="link.contact" /></NavText>
              </NavItem>
            </SideNav.Nav>
            <div className="sidenav-footer">
              <div className="language">
                <Button onClick={(e) => {
                  setExpanded(false);
                  document.body.classList.remove("side-expanded");
                  setLocale("en");
                }} variant="link">
                  <img src="/icons/uk.png" alt="uk" />
                </Button>
                <Button onClick={(e) => {
                  setExpanded(false);
                  document.body.classList.remove("side-expanded");
                  setLocale("fr")
                }} variant="link">
                  <img src="/icons/france.png" alt="france" />
                </Button>
              </div>
              <div className="f-s-links">
                <a href={`${process.env.REACT_APP_WP_SITE_ROOT}/privacy-policy/`} rel="noopener noreferrer" target="_blank" to="/"><FormattedMessage id="nav.legal" /></a>
                <Link to="/">
                  <img src="/icons/help.png" alt="help" />
                </Link>
              </div>
            </div>
          </SideNav>
        </ClickOutside>
      )}
    />
  );
};

export default Sidebar;
